import { Button } from "@/components/ui/button";
import { lovable } from "@/integrations/lovable";
import { toast } from "sonner";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

interface AppleSignInButtonProps {
  label?: string;
  className?: string;
}

export function AppleSignInButton({ label = "Fortsätt med Apple", className }: AppleSignInButtonProps) {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleClick = async () => {
    setLoading(true);
    const result = await lovable.auth.signInWithOAuth("apple", {
      redirect_uri: window.location.origin,
    });

    if (result.error) {
      setLoading(false);
      toast.error("Det gick inte att logga in med Apple");
      return;
    }

    if (result.redirected) {
      // Browser will redirect to Apple
      return;
    }

    // Authenticated — gate will redirect to /profil-setup if profile is incomplete
    setLoading(false);
    toast.success("Inloggad!");
    navigate("/dashboard");
  };

  return (
    <Button
      type="button"
      variant="outline"
      className={className}
      onClick={handleClick}
      disabled={loading}
    >
      <svg className="mr-2 h-4 w-4" viewBox="0 0 384 512" fill="currentColor" aria-hidden="true">
        <path d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zM229.6 99.4c20.6-24.4 18.7-46.6 18.1-54.6-18.2 1.1-39.3 12.4-51.3 26.4-13.2 15-21 33.6-19.3 53.7 19.7 1.5 37.7-8.6 52.5-25.5z"/>
      </svg>
      {loading ? "Loggar in…" : label}
    </Button>
  );
}
